<app-page-bar></app-page-bar>

<app-page>
  <div class="settings-grid">
    <!--<div fxLayout="column" fxFlex="100%" fxLayoutGap="1rem">-->
      <mat-card class="item" routerLink="/settings/lead-sources">
        <mat-card-content>
          <mat-icon>support_agent</mat-icon>
          <h3>Lead Sources</h3>
        </mat-card-content>
      </mat-card>
      <mat-card class="item" routerLink="/settings/partners">
        <mat-card-content>
          <mat-icon>money</mat-icon>
          <h3>Partners</h3>
        </mat-card-content>
      </mat-card>
      <mat-card class="item" routerLink="/settings/templates">
        <mat-card-content>
          <mat-icon>description</mat-icon>
          <h3>Templates</h3>
        </mat-card-content>
      </mat-card>
    <!--</div>-->
  </div>
</app-page>
